import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "pl-2" }
const _hoisted_2 = { class: "headline-5 w100 mt-2 mb-1" }
const _hoisted_3 = { class: "subtitle-1" }
const _hoisted_4 = { class: "ma-0" }
const _hoisted_5 = { class: "ma-0" }
const _hoisted_6 = {
  key: 0,
  class: "px-4 pb-2"
}
const _hoisted_7 = {
  key: 0,
  class: "auto py-2 px-2 flex"
}
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", null, "Download", -1)
const _hoisted_10 = { key: 0 }
const _hoisted_11 = ["href"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("h5", null, "References", -1)
const _hoisted_13 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_notification_bell = _resolveComponent("notification-bell")!
  const _component_fav_modal_button = _resolveComponent("fav-modal-button")!
  const _component_help_button = _resolveComponent("help-button")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_favourite_icon = _resolveComponent("favourite-icon")!
  const _component_ion_skeleton_text = _resolveComponent("ion-skeleton-text")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_img = _resolveComponent("ion-img")!
  const _component_ion_avatar = _resolveComponent("ion-avatar")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_chip = _resolveComponent("ion-chip")!
  const _component_splash_placeholder = _resolveComponent("splash-placeholder")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_list_header = _resolveComponent("ion-list-header")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_video_frame = _resolveComponent("video-frame")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_resources_in_area = _resolveComponent("resources-in-area")!
  const _component_other_articles_box = _resolveComponent("other-articles-box")!
  const _component_upcoming_events_box = _resolveComponent("upcoming-events-box")!
  const _component_sidebar_box = _resolveComponent("sidebar-box")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_toolbar, { onClick: _ctx.scrollTop }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_buttons, { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_back_button)
                ]),
                _: 1
              }),
              _createVNode(_component_ion_buttons, { slot: "end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_notification_bell, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet
                  }, null, 8, ["parent"]),
                  _createVNode(_component_fav_modal_button, {
                    parent: _ctx.$parent!.$refs.ionRouterOutlet,
                    articleId: _ctx.article ? _ctx.article.id : null
                  }, null, 8, ["parent", "articleId"]),
                  _createVNode(_component_help_button)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"])
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, { ref: "content" }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, { class: "w100" }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_grid, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_row, { class: "mx-4 pt-4" }, {
                            default: _withCtx(() => [
                              (!_ctx.loading && _ctx.article)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    "size-xs": "12",
                                    "size-sm": "11",
                                    "size-md": "11",
                                    "size-lg": "11",
                                    "size-xl": "11",
                                    size: "11"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", {
                                        class: "flex",
                                        style: _normalizeStyle([{"border-radius":"2px"}, {
                      'border-left':
                        '3px solid rgb(' +
                        _ctx.getColor(_ctx.article.category ? _ctx.article.category.name : '') +
                        ')',
                    }])
                                      }, [
                                        _createElementVNode("div", _hoisted_1, [
                                          _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.article.title), 1),
                                          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.article.subTitle), 1)
                                        ])
                                      ], 4)
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (!_ctx.loading && _ctx.article)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 1,
                                    class: "pr-4 flex",
                                    "size-xs": "12",
                                    "size-sm": "1",
                                    "size-md": "1",
                                    "size-lg": "1",
                                    "size-xl": "1",
                                    size: "1"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_favourite_icon, {
                                        articleId: _ctx.article.id,
                                        class: "o-7",
                                        style: {"margin":"auto 0px auto auto"}
                                      }, null, 8, ["articleId"])
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.loading)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 2,
                                    size: "10",
                                    class: "mt-4",
                                    style: {"margin-left":"48px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"60%"} }),
                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"88%"} })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "mx-4" }, {
                            default: _withCtx(() => [
                              (!_ctx.loading && _ctx.article && _ctx.article.author)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 0,
                                    size: "auto"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_item, { lines: "none" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_avatar, { slot: "start" }, {
                                            default: _withCtx(() => [
                                              (_ctx.article.author.avatar)
                                                ? (_openBlock(), _createBlock(_component_ion_img, {
                                                    key: 0,
                                                    alt: "avatar",
                                                    src: 
                            _ctx.article.author.avatar.formats.thumbnail
                              ? _ctx.article.author.avatar.formats.thumbnail.url
                              : _ctx.article.author.avatar.url
                          
                                                  }, null, 8, ["src"]))
                                                : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_ion_label, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("h5", _hoisted_4, _toDisplayString(_ctx.article.author ? _ctx.article.author.name : "No Author"), 1),
                                              _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.article.author.description ?? ""), 1)
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (_ctx.loading)
                                ? (_openBlock(), _createBlock(_component_ion_col, {
                                    key: 1,
                                    size: "10",
                                    class: "mt-4",
                                    style: {"margin-left":"48px"}
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"50%"} }),
                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"50%"} })
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "mx-4" }, {
                            default: _withCtx(() => [
                              (_ctx.article)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.topics, (topic) => {
                                      return (_openBlock(), _createBlock(_component_ion_chip, {
                                        color: "primary",
                                        outline: "",
                                        onClick: ($event: any) => (_ctx.$router.push('/home/search?search=' + topic.name)),
                                        key: topic.id + '-topic'
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_label, { color: "primary" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(topic.name), 1)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    }), 128))
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_row, { class: "mx-4" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_col, { size: "12" }, {
                                default: _withCtx(() => [
                                  (_ctx.article)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        (_ctx.article.splash && _ctx.article.splash.formats)
                                          ? (_openBlock(), _createBlock(_component_ion_img, {
                                              key: 0,
                                              alt: "splash",
                                              class: "splash-placeholder auto",
                                              src: 
                          _ctx.article.splash.formats.large
                            ? _ctx.article.splash.formats.large.url
                            : _ctx.article.splash.formats.medium
                            ? _ctx.article.splash.formats.medium.url
                            : _ctx.article.splash.url
                        
                                            }, null, 8, ["src"]))
                                          : _createCommentVNode("", true),
                                        (!_ctx.article.splash || !_ctx.article.splash.formats)
                                          ? (_openBlock(), _createBlock(_component_splash_placeholder, {
                                              key: 1,
                                              class: "splash-placeholder auto",
                                              category: _ctx.article.category ? _ctx.article.category.name : ''
                                            }, null, 8, ["category"]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }),
                          (!_ctx.loading && _ctx.article)
                            ? (_openBlock(), _createBlock(_component_ion_row, {
                                key: 0,
                                class: "ion-justify-content-center mx-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    "size-lg": "12",
                                    "size-md": "12",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      (_ctx.article.body)
                                        ? (_openBlock(), _createElementBlock("pre", {
                                            key: 0,
                                            class: "px-2",
                                            innerHTML: _ctx.$marked(_ctx.article.body)
                                          }, null, 8, _hoisted_8))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (_ctx.loading)
                            ? (_openBlock(), _createBlock(_component_ion_row, {
                                key: 1,
                                class: "ion-justify-content-center mx-0"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    "size-lg": "12",
                                    "size-md": "10",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_list, null, {
                                        default: _withCtx(() => [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.mocks, (block) => {
                                            return (_openBlock(), _createBlock(_component_ion_item, {
                                              class: "px-4",
                                              lines: "none",
                                              key: block + '-block'
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_label, null, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("h3", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"90%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"100%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"92%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"90%"} })
                                                    ]),
                                                    _createElementVNode("p", null, [
                                                      _createVNode(_component_ion_skeleton_text, { style: {"width":"95%"} })
                                                    ])
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (
                    !_ctx.loading &&
                    _ctx.article &&
                    _ctx.article.resources &&
                    _ctx.article.resources.length
                  )
                            ? (_openBlock(), _createBlock(_component_ion_row, {
                                key: 2,
                                class: "ion-justify-content-center mx-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    "size-lg": "12",
                                    "size-md": "12",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_list, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_ion_list_header, null, {
                                            default: _withCtx(() => [
                                              _hoisted_9
                                            ]),
                                            _: 1
                                          }),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.article.resources, (resource) => {
                                            return (_openBlock(), _createBlock(_component_ion_item, {
                                              key: resource.id + 'resource'
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_ion_avatar, { slot: "start" }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_ion_icon, {
                                                      size: "large",
                                                      icon: _ctx.documentOutline
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 1
                                                }),
                                                _createVNode(_component_ion_label, { class: "ion-text-wrap" }, {
                                                  default: _withCtx(() => [
                                                    _createElementVNode("h3", null, _toDisplayString(resource.title) + " " + _toDisplayString(resource.file ? resource.file.ext : ''), 1),
                                                    (resource.file)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString((resource.file.size / 1000).toFixed(2)) + " MB ", 1))
                                                      : _createCommentVNode("", true)
                                                  ]),
                                                  _: 2
                                                }, 1024),
                                                _createElementVNode("a", {
                                                  slot: "end",
                                                  href: resource.file.url,
                                                  target: "_self"
                                                }, [
                                                  _createVNode(_component_ion_button, {
                                                    class: "auto my-pointer mr-2",
                                                    icon: "",
                                                    fill: "none"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_ion_icon, {
                                                        icon: _ctx.openOutline,
                                                        size: "large"
                                                      }, null, 8, ["icon"])
                                                    ]),
                                                    _: 1
                                                  })
                                                ], 8, _hoisted_11)
                                              ]),
                                              _: 2
                                            }, 1024))
                                          }), 128))
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (!_ctx.loading && _ctx.article && _ctx.article.videoURL)
                            ? (_openBlock(), _createBlock(_component_ion_row, {
                                key: 3,
                                class: "ion-justify-content-center py-4 mx-4"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    "size-lg": "12",
                                    "size-md": "12",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_video_frame, {
                                        src: _ctx.article.videoURL
                                      }, null, 8, ["src"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          (!_ctx.loading && _ctx.article && _ctx.article.reference)
                            ? (_openBlock(), _createBlock(_component_ion_row, {
                                key: 4,
                                class: "ion-justify-content-center py-4 mx-2"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_col, {
                                    "size-lg": "12",
                                    "size-md": "12",
                                    size: "12"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_ion_list_header, null, {
                                        default: _withCtx(() => [
                                          _hoisted_12
                                        ]),
                                        _: 1
                                      }),
                                      (_ctx.article.reference)
                                        ? (_openBlock(), _createElementBlock("pre", {
                                            key: 0,
                                            class: "px-4 ma-0",
                                            innerHTML: _ctx.$marked(_ctx.article.reference)
                                          }, null, 8, _hoisted_13))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  (_ctx.innerWidth > 1400)
                    ? (_openBlock(), _createBlock(_component_ion_col, { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_sidebar_box, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_resources_in_area),
                              _createVNode(_component_other_articles_box, { title: "Related Articles" }),
                              _createVNode(_component_upcoming_events_box, { class: "mt-2" })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }))
}